var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploaddelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81514 1.6748H8.0253M1.60498 3.34967H11.2355M10.1654 3.34967L9.7902 9.22247C9.73391 10.1036 9.70576 10.5442 9.52339 10.8782C9.36282 11.1723 9.12063 11.4087 8.82873 11.5563C8.49718 11.724 8.07404 11.724 7.22776 11.724H5.61268C4.7664 11.724 4.34326 11.724 4.01171 11.5563C3.71981 11.4087 3.47762 11.1723 3.31706 10.8782C3.13468 10.5442 3.10653 10.1036 3.05024 9.22248L2.67503 3.34967M5.35017 5.86197V8.65342M7.49028 5.86197V8.65342",
    stroke: "#A4A7AE",
    strokeWidth: 1.07005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaddelete);
export default __webpack_public_path__ + "static/media/uploaddelete.82f390a4459266add780832e436b138a.svg";
export { ForwardRef as ReactComponent };